@import '@hevoio/hevo-ui-toolkit/styles/variables';

.helpItemList {
  list-style: none;

  li {
    position: relative;
    padding-left: 1.16rem;

    &::before {
      content: '';
      position: absolute;
      display: inline-block;
      border: solid $border-width #6b63ff;
      border-radius: 50%;
      left: 0;
      top: 0.5rem;
      height: 6px;
      width: 6px;
    }
  }
}
